<template>
  <div class="welcomepage">
    <div class="welcomepage" :style="setWelImg" />
    <Modal v-model="isShowPwModal" title="修改密码" cancel-text="" ok-text="" mask :mask-closable="false" footer-hide>
      <ChangePassword @onSwichPwModal="onSwichPwModal" openFrom="welcome" />
    </Modal>
  </div>
</template>

<script>
import { branch, SURVEY_URL } from '@/constants/global';
import closedImg from 'branchImages/logo.png';
import openedImg from 'branchImages/logo.png';
import ChangePassword from '../src/component/lining/modal/ChangePassword'
export default {
  name: "WelcomePage",
  data() {
    return {
      isShowPwModal: false
    }
  },
  components: {
    ChangePassword
  },
  computed: {
    setWelImg() {
      return `background: url(/src/assets/images/${branch}/homepage_BRAND_PIC.png) no-repeat center /100%   ;`;
    }
  },
  created() {
    let imgSrc = {
      closedImg,
      openedImg
    };
    this.$store.commit('global/updateImage', imgSrc);

  },
  mounted() {
    this.checkPwModal()
    // SYSTEM/TABLE/PC_C_TASK/249130092
    // this.$store.commit("global/tabOpen", {
    //     type: "S",
    //     tableName: 'PC_C_TASK',
    //     tableId: 249130092,
    // })

    // SYSTEM/TABLE_DETAIL/V/CP_C_STORE_INFO_CHG/249130166/22
    // this.$store.commit("global/tabOpen", {
    //     type: 'tableDetailVertical',
    //     tableName: 'CP_C_STORE_INFO_CHG',
    //     tableId: 249130166,
    //     id: 22,
    // })

    // CUSTOMIZED/CP_C_INORG/2086
    // CUSTOMIZED/UNIFIEDTASK/2086
    // this.$store.commit("global/tabOpen", {
    //     type: 'C',
    //     label:"数据看板分析c",
    //     customizedModuleName:"DATAKANBAN",
    //     customizedModuleId:"31460153"
    // });


    // let isAdmin = localStorage.getItem('isAdmin')
    // // console.log('isAdmin :>> ', isAdmin);
    // if (isAdmin == 'false') {
      // this.$store.commit("global/tabOpen", {
      //   type: 'C',
      //   label: "统一待办",
      //   customizedModuleName: "UnifiedTask",
      //   customizedModuleId: "31460266"
      // });
    // }
    
    
    var userName = localStorage.getItem('userName');
    let script = document.createElement('script');
    script.src = SURVEY_URL;
    console.log("userName:" + userName + ",url:" + script.src);
    script.onload = () => {
      window.handleSurvey('CMS', userName)
    }  
    document.head.appendChild(script);
  },
  methods: {
    checkPwModal() {
      let needModifyPassWord = sessionStorage.getItem("needModifyPassWord");
      if (needModifyPassWord) {
        this.onSwichPwModal()
        // this.$Modal.fcWarning({
        //     mask: true,
        //     title: '提示',
        //     content: "密码过于简单，请修改密码",
        //     onOk: () => {
        //         this.onSwichPwModal()
        //     },
        //     onCancel: ()=>{
        //         // this.onSwichPwModal()
        //     }
        // });
      } else {
         this.$store.commit("global/tabOpen", {
          type: 'C',
          label: "统一待办",
          customizedModuleName: "UnifiedTask",
          customizedModuleId: "31460266"
        });
      }
    },
    onSwichPwModal() {
      this.isShowPwModal = !this.isShowPwModal
    }
  }
};
</script>

<style  lang="less">
.welcomepage {
  width: 100%;
  height: 100%;
}
.navigator .left img.trigger {
  height: 50px;
  z-index: 1;
}
.navigator .left img.logo {
  position: absolute;
  width: 30px;
  top: 10px;
  left: 18px;
  z-index: -1;
}
</style>
